<template>
  <transition name="scale">
    <div
      class="customModal fillForm goodsForm"
      v-show="visible"
      >
      <Form ref="form" @success="add_manufacturer" />
      <div class="title" >
        <div class="btns">
          <el-radio-group v-model="radioValue">
            <el-radio-button label="1"><span class="red">*</span>药品基本信息</el-radio-button>
            <el-radio-button label="2">药品说明书</el-radio-button>
            <el-radio-button label="3">药品资质证明</el-radio-button>
          </el-radio-group>
        </div>
        <div @click="close" class="operate">
          <i class="fa fa-share fa-2" aria-hidden="true"></i>返回商品列表页
        </div>
      </div>
      <el-tabs class="content" v-if="visible" v-model="radioValue" type="card" @tab-click="tabClick">
        <el-tab-pane label="药品基本信息" name="1">
          <AppForm
            ref="form1"
            hiddenBtns
            labelWidth="110px"
            formStyle="default"
            @fieldsChange="fieldsChange"
            :rules="rules1"
            :defaultValues="defaultValues"
            :fields="formFieldsInfo">
            <template slot="manufacturer_id">
              <AppButton size="small" type="primary" plain @click="addManufacturer">
                <i class="fa fa-plus fa-lg icon"></i>新增
              </AppButton>&emsp;
            </template>
          </AppForm>
          <el-form v-if="defaultValues.is_distribution">
            <el-row>
              <el-col :span="6">
                <el-form-item label="是否参与分销">
                  <el-radio-group v-model="defaultValues.distribution.nocommission" style="float:left;margin-left:20px;margin-top:10px">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否启用独立规则" v-if="defaultValues.distribution.nocommission">
                  <el-radio-group v-model="defaultValues.distribution.hascommission" style="float:left;margin-left:20px;margin-top:10px">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <div v-if="defaultValues.distribution.hascommission&&defaultValues.distribution.nocommission">
                <el-col :span="4">
                  <el-form-item label="一级佣金">
                    <el-input v-model="defaultValues.distribution.commission1" style="float:left;margin-left:20px;width:50%">
                        <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="二级佣金">
                    <el-input v-model="defaultValues.distribution.commission2" style="float:left;margin-left:20px;width:50%">
                        <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="三级佣金">
                    <el-input v-model="defaultValues.distribution.commission3" style="float:left;margin-left:20px;width:50%">
                        <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="药品说明书" name="2">
          <AppForm
            ref="form2"
            hiddenBtns
            labelWidth="110px"
            formStyle="default"
            @fieldsChange="fieldsChange"
            :rules="rules2"
            :defaultValues="defaultValues2"
            :fields="formFieldsExplain">
          </AppForm>
        </el-tab-pane>
        <el-tab-pane label="药品资质证明" name="3">
          <AppForm
            ref="form3"
            hiddenBtns
            formStyle="default"
            @fieldsChange="fieldsChange"
            :rules="rules3"
            :defaultValues="defaultValues3"
            :fields="formFieldsImages"/>
        </el-tab-pane>
        <div class="btns">
          <AppButton customType="default" @click ="submit" :loading="loading">提交保存</AppButton>
        </div>
      </el-tabs>
    </div>
  </transition>
</template>

<script>
import { GoodsService } from '../../service/goods.service';
import Form from './formManufacturer';
import { copyArrParam } from '../../utils/index';
import moment from 'moment';
const formFieldsInfo = [
  { type: 'image', key: 'original_img', pathType: 'goods', label: '商品主图', limit: 1, span: 24 },
  { type: 'image', key: 'images', pathType: 'goods', label: '附图', limit: 9999, span: 24, multiple: true },
  { type: 'input', key: 'goodsId', label: 'ERP商品ID' },
  { type: 'input', key: 'goods_name', label: '商品名称' },
  { type: 'input', key: 'common_name', label: '通用名' },
  { type: 'textarea', key: 'goods_remark', label: '药品描述' },
  { type: 'textarea', key: 'goods_content', label: '详情描述' },
  { type: 'cascader', key: 'cat_id', label: '商品类型', showAllLevels: false, options: [ { label: '测试', value: '23' }], props: { emitPath: false,  children: 'sub', label: 'name', value: 'id' }, span: 12 },
  // { type: 'select', key: 'brand_id', label: '品牌', options: [ { label: '测试', value: '23' }], span: 6 },
  { type: 'select_custom', key: 'manufacturer_id', label: '生产厂商', options: [], span: 12 },
  { type: 'input', key: 'goods_code', label: '商品代码' },
  { type: 'input', key: 'goods_spec', label: '商品规格' },
  { type: 'input', key: 'store_count', label: '商品库存' },
  { type: 'input', key: 'unit', label: '单位' },
  { type: 'input', key: 'pinyin_name', label: '拼音名' },
  { type: 'input', key: 'keywords', label: '关键字' },
  { type: 'input', key: 'mid_pack', label: '中包装', span: 6 },
  { type: 'input', key: 'big_pack', label: '大包装', span: 6 },
  { type: 'radio', key: 'is_on_sale', label: '上架', span: 6, options: [ { label: '是', value: 1 }, { label: '否', value: 0 }] },
  { type: 'radio', key: 'is_new', label: '新品', span: 6, options: [ { label: '是', value: 1 }, { label: '否', value: 0 }] },
  { type: 'radio', key: 'virtual_refund', label: '允许退款', span: 6, options: [ { label: '是', value: 1 }, { label: '否', value: 0 }] },
  { type: 'radio', key: 'is_recommend', label: '推荐', span: 6, options: [ { label: '是', value: 1 }, { label: '否', value: 0 }] },
  { type: 'radio', key: 'is_advertising', label: '广告', span: 6, options: [ { label: '是', value: 1 }, { label: '否', value: 0 }] },
  { type: 'radio', key: 'is_hot', label: '热门', span: 6, options: [ { label: '是', value: 1 }, { label: '否', value: 0 }] },
  { type: 'input', key: 'market_price', label: '零售价', span: 6 },
  { type: 'input', key: 'wholesale_price', label: '批发价', span: 6 },
  { type: 'radio', hidden: true, key: 'is_free_shipping', label: '是否包邮', span: 6, options: [ { label: '是', value: 1 }, { label: '否', value: 0 }] },
  { type: 'input', hidden: true, key: 'shipping_fee', label: '邮费', span: 6 },
  { type: 'input', key: 'sort', label: '商品排序值', span: 6 },
  { type: 'input', key: 'exchange_integral', label: '可兑换积分', span: 6 },
  { type: 'input', key: 'give_integral', label: '购买送积分', span: 6 },
  { type: 'radio', hidden: true, key: 'is_healthcare', label: '是否医保', options: [ { label: '是', value: 1 }, { label: '否', value: 0 }], span: 6 },
  { type: 'select', key: 'medicine_type', label: '处方类型', options: [], span: 6 },
  { type: 'select', key: 'cn_medicine', label: '中药类型', options: [], span: 6 },
  { type: 'select', key: 'healthcare_type', label: '医保类型', options: [], span: 6 },
  { type: 'select', key: 'dosage_form', label: '剂型', options: [], span: 6 },
];
const formFieldsExplain = [
  { type: 'input', key: 'approval_number', label: '批准文号', span: 24 },
  { type: 'textarea', key: 'component', label: '成分', span: 24 },
  { type: 'textarea', key: 'management', label: '功能主治', span: 24 },
  { type: 'textarea', key: 'dosage', label: '用法用量', span: 24 },
  { type: 'textarea', key: 'adverse_reaction', label: '不良反应', span: 24 },
  { type: 'textarea', key: 'character', label: '症状', span: 24 },
  { type: 'textarea', key: 'taboo', label: '禁忌', span: 24 },
  { type: 'textarea', key: 'attentions', label: '注意事项', span: 24 },
  { type: 'textarea', key: 'interaction', label: '药物相互作用', span: 24 },
  { type: 'input', key: 'packing', label: '包装', span: 6 },
  { type: 'input', key: 'storage', label: '贮藏', span: 6 },
  { type: 'daterange', key: 'shelf_life', label: '有效期' },
];

const formFieldsImages = [
  { type: 'image', pathType: 'goods', key: 'approval_document', label: '药品生产或者进口批准证明文件复印件', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'quality_standard', label: '药品质量标准复印件', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'instructions_packaging_labels', label: '	药品说明书、包装、标签备案件复印件', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'box_instructions', label: '药品样盒、说明书实样', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'price_confirmation', label: '药品价格确认表或物价单复印件', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'inspection_report', label: '药品检验报告书', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'business_production', label: '药品生产企业的营业执照复印件药品生产许可证复印件', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'gmp', label: '在有效期内的与品种剂型相适应的GMP认证证书复印件', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'chromium_inspection', label: '胶囊剂药品需提供合格的铬检验报告单复印件', size: 'big', limit: 1, span: 8 },
  { type: 'image', pathType: 'goods', key: 'oct', label: 'OTC产品提供《非处方药药品审核登记证书》复印件', size: 'big', limit: 1, span: 8 },
  { type: 'date', key: 'expiration_date', label: '有效期', span: 8 }
];

const rules1 = {
  original_img: [{ required: true, message: '请选择主图'}],
  images: [{ required: true, message: '请选择附图'}],
  goodsId: [{ required: true, message: '请输入ERP商品ID'}],
  goods_name: [{ required: true, message: '请输入商品名称'}],
  common_name: [{ required: true, message: '请输入通用名'}],
  manufacturer_id: [{ required: true, message: '请选择生产厂商'}],
  cat_id: [{ required: true, message: '请选择商品分类'}],
  goods_code: [{ required: true, message: '请输入商品代码'}],
  sort: [{ required: true, message: '请输入排序值'}],
  goods_spec: [{ required: true, message: '请输入商品规格'}],
  store_count: [{ required: true, message: '请输入商品库存'}],
  unit: [{ required: true, message: '请输入商品单位'}],
  pinyin_name: [{ required: true, message: '请输入拼音名'}],
  mid_pack: [{ required: true, message: '请输入中包装'}],
  big_pack: [{ required: true, message: '请输入大包装'}],
  market_price: [{ required: true, message: '请输入零售价'}],
  wholesale_price: [{ required: true, message: '请输入批发价'}],
  is_free_shipping: [{ required: true, message: '请选择是否包邮'}],
  is_healthcare: [{ required: true, message: '请选择是否医保'}],
  dosage_form: [{ required: true, message: '请选择剂型'}],
  healthcare_type: [{ required: true, message: '请选择医保类型'}],
  medicine_type: [{ required: true, message: '请选择处方类型'}],
  cn_medicine: [{ required: true, message: '请选择中药类型'}],
};

const rules2 = {
  // shelf_life: [{ required: true, message: '有效期不能为空'}],
  // attentions: [{ required: true, message: '注意事项不能为空'}],
  // approval_number: [{ required: true, message: '批准文号不能为空'}],
  // interaction: [{ required: true, message: '药物相互作用不能为空'}],
};

const rules3 = {
  // approval_document: [{ required: true, message: '请选择图片'}],
  // quality_standard: [{ required: true, message: '请选择图片'}],
  // instructions_packaging_labels: [{ required: true, message: '请选择图片'}],
  // box_instructions: [{ required: true, message: '请选择图片'}],
  // price_confirmation: [{ required: true, message: '请选择图片'}],
  // inspection_report: [{ required: true, message: '请选择图片'}],
  // business_production: [{ required: true, message: '请选择图片'}],
  // gmp: [{ required: true, message: '请选择图片'}],
  // chromium_inspection: [{ required: true, message: '请选择图片'}],
  // oct: [{ required: true, message: '请选择图片'}],
};
  export default {
    name: 'formGoodsList',
    props: [ 'menuData' ],
    components: { Form },
    data() {
      return {
        loading: false,
        visible: false,
        formFieldsInfo,
        formFieldsExplain,
        formFieldsImages,
        openType: 'add',
        defaultValues: {},
        defaultValues2: {},
        defaultValues3: {},
        rules1,
        rules2,
        rules3,
        imageList: [],
        categoryList: [],
        brandList: [],
        radioValue: '1',
      }
    },
    async created() {
      // this.formFieldsInfo[27].change = this.freePostage;
      // this.formFieldsInfo[32].change = this.healthChange;
    },
    methods: {
      handleMenuData() {
        this.formFieldsInfo[this.formFieldsInfo.length-1].options = this.menuData.dosage_form
        this.formFieldsInfo[7].options = this.menuData.category.map(item => {
          item.sub.map(v => delete v.sub);
          return item;
        });
        this.formFieldsInfo[8].options = this.menuData.manufacturer;
        this.formFieldsInfo[this.formFieldsInfo.length-3].options = this.menuData.cn_medicine;
        this.formFieldsInfo[this.formFieldsInfo.length-4].options = this.menuData.medicine_type;
        this.formFieldsInfo[this.formFieldsInfo.length-2].options = this.menuData.healthcare_type;
        // this.formFieldsInfo[7].options = this.menuData.brands;
      },
      healthChange(value) {
        this.formFieldsInfo[34].hidden = !value;
        this.formFieldsInfo = [...this.formFieldsInfo];
      },
      freePostage(value) {
        this.formFieldsInfo[27].hidden = !!value;
        this.formFieldsInfo = [...this.formFieldsInfo];
      },
      open(type,data) {
        this.radioValue = '1';
        this.openType = type;
        this.handleMenuData();
        if (type === 'edit'){
          console.log("data",data);
          data.images.forEach((item, i) => {
            item.uid = i;
            item.name = '图片异常';
            item.status = 'done';
            item.url = GoodsService.spliceImg(item.image_url);
          });
          data.original_img = [{
            uid: '1',
            name: '图片异常',
            status: 'done',
            url: GoodsService.spliceImg(data.original_img),
          }]
          this.defaultValues = JSON.parse(JSON.stringify(data));
          if(data.instructions && data.instructions.shelf_life) {
            data.instructions.shelf_life = data.instructions.shelf_life.split(',');
            data.instructions.shelf_life[0] = new Date(data.instructions.shelf_life[0]);
            data.instructions.shelf_life[1] = new Date(data.instructions.shelf_life[1]);
          }
          this.defaultValues2 = JSON.parse(JSON.stringify(data.instructions));
          // this.healthChange(data.is_healthcare);
          // this.freePostage(data.is_free_shipping);
          if (data.certificates) {
            for (const key of Object.keys(data.certificates)) {
              if (typeof data.certificates[key] === 'string' && data.certificates[key].includes('static/upload')) {
                data.certificates[key] = [{
                  uid: key,
                  name: '图片异常',
                  status: 'done',
                  url: GoodsService.spliceImg(data.certificates[key]),
                }];
              }
            }
            data.certificates.expiration_date = moment(data.certificates.expiration_date).toDate();
          }
          this.defaultValues3 = JSON.parse(JSON.stringify(data.certificates));
        } else {
          this.defaultValues = {
            virtual_refund: 0,
            is_new: 0,
            is_hot: 0,
            is_on_sale: 0,
            is_advertising: 0,
            is_recommend: 0,
          };
          this.defaultValues2 = {};
          this.defaultValues3 = {};
        }
        console.log("this.defaultValues",this.defaultValues);
        this.visible = true;
      },
      loadCacheOpen() {
        this.openType = 'add';
        this.radioValue = this.$store.state.goods.radioValue;
        this.handleMenuData()
        this.defaultValues = this.$store.state.goods.autoSaveData.form1;
        this.defaultValues2 = this.$store.state.goods.autoSaveData.form2;
        this.defaultValues3 = this.$store.state.goods.autoSaveData.form3;
        this.visible = true;
      },
      close() {
        this.$store.commit({ type: 'GOODSUPDATESABED'});
        this.visible = false;
      },
      tabClick() {

      },
      async fieldsChange() {
        await this.$store.commit({ type: 'GOODSSAVEDATA', data: {
            form1: this.$refs.form1.formValue,
            form2: this.$refs.form2.formValue,
            form3: this.$refs.form3.formValue,
          },
          radioValue: this.radioValue
        });
      },
      addManufacturer() {
        this.$refs.form.open();
      },
      async add_manufacturer() {
        const data = await GoodsService.getList();
        copyArrParam(data.manufacturer, { label: 'name', value: 'id' });
        this.formFieldsInfo[8].options = data.manufacturer;
        this.$forceUpdate()
      },
      async submit() {
        this.loading = true;
        let form1, form2, form3
        try {
          form1 = await this.$refs.form1.submit();
          form2 = await this.$refs.form2.submit();
          form3 = await this.$refs.form3.submit();
          // if (form1 && form2 && form3) {
          if (form1) {
            await GoodsService.save(form1, form2, form3);
            this.$emit('success');
            this.close();
          }
        } catch(error) {
          if (!form1) {
            this.radioValue = '1';
          }
          //  else if (!form2) {
          //   this.radioValue = '2';
          // } else if (!form3) {
          //   this.radioValue = '3';
          // }
        } finally {
          this.loading = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.content {
  & /deep/ .el-tabs__content {
    padding: 20px;
  }
}
.red{
  color: red;
  margin-right: 5px;
}

</style>